import * as React from 'react';
import { withLocalize, LocalizeContextProps, Language as LocalizeLanguage } from 'react-localize-redux';
import { Menu, Dropdown, Icon, Button } from 'antd';
import bindAllOfThis from "src/utils/BindThisHelper";
import AccountApiController from 'src/api/AccountApiController';
import Languages, { Language } from 'src/constants/Languages';

interface LanguageToggleProps extends LocalizeContextProps {
}

class LanguageToggle extends React.Component<LanguageToggleProps> {
    constructor(props: LanguageToggleProps) {
        super(props);
        bindAllOfThis(this, LanguageToggle.prototype);
    }

    componentWillReceiveProps(nextProps: LanguageToggleProps) {
        if (nextProps.activeLanguage !== this.props.activeLanguage) {
            // This has to be here, otherwise the translate() function will not have the proper active language
            let language = Languages.FindByCode(nextProps.activeLanguage.code);
            Languages.SetActiveLanguage(language, nextProps.translate);
        }
    }

    changeCurrentLanguage(lang: Language) {
        this.props.setActiveLanguage(lang.code);
        AccountApiController.updateSelectedCulture(lang.id);
    }

    renderMenuItems(currentLanguage: LocalizeLanguage) {
        // Load available languages
        let languages = Languages.All.filter(x => x.isAvailable);
        if (languages == null || languages.length < 1) {
            languages.push({ id: -1, code: currentLanguage.code, name: currentLanguage.name } as Language);
        }
        return languages.map(lang => (
            <Menu.Item
                tabIndex={2}
                key={lang.code}
                disabled={lang.code === currentLanguage.code}
                onClick={() => this.changeCurrentLanguage(lang)}>
                {lang.name}
            </Menu.Item>
        ));
    }

    renderMenu(currentLanguage: LocalizeLanguage) {
        return <Menu>{this.renderMenuItems(currentLanguage)}</Menu>;
    }

    render() {
        // Have to do this for defaults. Language comes in initially unset
        let currentLanguage = (this.props.activeLanguage || { name: "Language", code: "ln" } as LocalizeLanguage);

        return <Dropdown className="language-dropdown" overlay={this.renderMenu(currentLanguage)} trigger={["click"]}>
        <Button tabIndex={2} type="primary">
            {currentLanguage.name} <Icon type="down" />
        </Button>
    </Dropdown>;
    }
}

export default withLocalize(LanguageToggle);



// WEBPACK FOOTER //
// ./src/components/common/LanguageToggle.tsx